import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { 
  Menu, 
  MenuOpen, 
  Close,
} from "@mui/icons-material";
import Logonew from "../../assets/logonew2.webp";
import { 
  Home, LogOut, Group, Settings, 
  GraphUp, ShopAlt, Packages, Cart, 
  UserCart, NavArrowDown, UserCircleAlt, PenConnectWifi, 
  Building, WarningTriangleOutline, SettingsProfiles, SendMail,
  MediaImageList, Megaphone, Tv, ChatBubbleCheck,
  Svg3DPtBox, City, RefreshCircular, MapsArrow, ReportColumns,
  TaskList } from "iconoir-react";
import { Drawer, IconButton, useMediaQuery, useTheme } from "@mui/material";
import { domain } from "../../Urls/Services/Api_urls";
import Swal from "sweetalert2";

export default function Dashboard({
  MInicio,
  Mempaquetar,
  Msolicitudes,
  Mservicios,
  Mcompra,
  Mcunyompra,
  Mcpotenciales,
  Madminportal,
  Mcampaña,
  children
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [isSidebarOpen, setIsSidebarOpen] = useState(!isMobile);
  const [openSubmenus, setOpenSubmenus] = useState({});
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Close sidebar by default on mobile
    if (isMobile) {
      setIsSidebarOpen(false);
    } else {
      setIsSidebarOpen(true);
    }
  }, [isMobile]);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);

  const id = window.sessionStorage.getItem("id");
  const token = window.sessionStorage.getItem("token");
  const groups = window.sessionStorage.getItem("groups");
  const ownername = window.sessionStorage.getItem("ownername");
  const url_logout = domain + `/logout/`;

  const toggleSubmenu = (path) => {
    setOpenSubmenus((prev) => ({
      ...prev,
      [path]: !prev[path],
    }));
  };

  const menuItems = [
    {
      path: "/Dashboardprincipal",
      name: "Inicio",
      icon: <Home />,
    },
    {
      path: "/solicitudes",
      name: "Solicitudes",
      icon: <UserCart />,
      submenu: [
        { path: "/Solicitud/[N,O]", name: "Noriente", icon: <MapsArrow /> },
        { path: "/Solicitud/[S,C,NA]", name: "SurCentro", icon: <MapsArrow /> },
        { path: "/SolicitudEmpresarial", name: "Empresariales", icon: <City /> },
        {
          path: "/solicitudes/reportes",
          name: "Reportes",
          icon: <ReportColumns/>,
          submenu: [
            { path: "/Reportes/[N,O]", name: "Reportes Norte", icon: <GraphUp />  },
            { path: "/Reportes/[S,C,NA]", name: "Reportes Sur", icon: <GraphUp />  },
          ],
        },
      ],
    },
    { path: "/Solicitud/[S,C,N,O,NA]", name: "Mis Solicitudes", icon: <UserCart /> },
    { path: "/Solicitud/[S,C,N,O]", name: "Solicitud PAP", icon: <TaskList /> },
    { path: "/AdminSol", name: "Mis servicios", icon: <PenConnectWifi /> },
    {
      path: "/ServiciosEmpresariales",
      name: "Servicios empresariales",
      icon: <Building />,
      submenu: [
        { path: "/Sedes", name: "Sedes", icon: <City /> },
        { path: "/ReportesPQR", name: "Reportes PQR", icon: <ReportColumns /> },
      ],
    },
    { path: "/createSolPer", name: "Comprar", icon: <Cart /> },
    { path: "/Empaquetarin", name: "Empaquetar", icon: <Packages /> },
    { path: "/Dashunycompra", name: "Venta unificada", icon: <ShopAlt /> },
    { path: "/Reportes/[S,N,C,O]", name: "Reportes PAP", icon: <GraphUp /> },
    {
      path: "/clientes-potenciales",
      name: "Clientes potenciales",
      icon: <Group />,
      submenu: [
        { path: "/CallSolicitudes/0", name: "Nuevos", icon: <WarningTriangleOutline /> },
        { path: "/CallSolicitudes/1", name: "Cerradas", icon: <SettingsProfiles /> },
        { path: "/sendemail", name: "Envio de correos", icon: <SendMail /> },
      ],
    },
    { path: "/administracion-portal", name: "Administración del portal", icon: <Settings />, 
      submenu: [
        { path: "/AdminImages", name: "Imagenes", icon: <MediaImageList /> },
        { path: "/Campaings", name: "Campañas", icon: <Megaphone /> },
        { path: "/Tvgrilla", name: "TV Grilla", icon: <Tv /> },
        { path: "/CausalAnul", name: "Anulacion", icon: <ChatBubbleCheck /> },
        { path: "/Polygon", name: "Poligonos", icon: <Svg3DPtBox /> },
        { path: "/AdminEmpresarial", name: "Empresarial", icon: <City /> },
      ],
    },
    // { path: "/campaña", name: "Empresarial", icon: <Building />,
    //   submenu: [
    //     { path: "/SolicitudEmpresarial", name: "Solicitudes empresariales", icon: <City /> },
    //     // { path: "/cerradas", name: "Solicitudes cerradas", icon: <City /> },
    //     { path: "/AdminEmpresarial", name: "Administracion", icon: <RefreshCircular /> },
    //   ],
    // },
  ];
  
  const renderMenuItems = (items, isMobile = false) => (
    <ul className={`${isMobile ? "space-y-1" : "space-y-2"} p-1 md:p-2`}>
      {items.map((item) => {
        const isActive = location.pathname === item.path;
        const isSubmenuOpen = openSubmenus[item.path];
        const ulPaddingClass = item.submenu && !isSidebarOpen ? "p-0" : "p-1 md:p-2";

        return (
          <li key={item.path}>
            <Link
              to={item.path}
              className={`flex items-center gap-2 md:gap-4 p-2 md:p-3 rounded-lg transition-colors ${
                item.disabled
                  ? "opacity-50 cursor-not-allowed text-gray-400"
                  : isActive
                  ? "bg-primary-500 text-colorprimary bg-gray-100"
                  : "hover:bg-gray-100 text-gray-700"
              }`}
              style={{ textDecoration: "none", cursor: item.disabled ? "not-allowed" : "pointer" }}
              onClick={(e) => {
                if (item.disabled) {
                  e.preventDefault();
                  return;
                }
                if (item.submenu) {
                  e.preventDefault();
                  toggleSubmenu(item.path);
                }
              }}
            >
              <span className={`text-lg md:text-xl ${item.disabled ? "text-gray-400" : isActive ? "text-colorprimarygreen" : "text-gray-700"}`}>
                {item.icon}
              </span>
              {(isSidebarOpen || isMobile) && (
                <span className={`text-sm md:text-base ${item.disabled ? "text-gray-400" : isActive ? "text-colorprimarygreen" : "text-gray-700"} whitespace-nowrap`}>
                  {item.name}
                  {item.disabled && <em className="ml-1 text-xs text-gray-400">(Próximamente)</em>}
                </span>
              )}
              {item.submenu && (
                <NavArrowDown
                  className={`ml-auto transition-transform ${
                    isSubmenuOpen ? "rotate-180" : ""
                  }`}
                />
              )}
            </Link>
            {item.submenu && isSubmenuOpen && (
              <div className={`${isSidebarOpen ? "pl-4 md:pl-10" : "pl-0"}`}>
                <ul className={`${isMobile ? "space-y-1" : "space-y-2"} ${ulPaddingClass}`}>
                  {renderMenuItems(item.submenu, isMobile)}
                </ul>
              </div>
            )}
          </li>
        );
      })}
    </ul>
  );

  const filterMenuItems = (items, allowedComponents) => {
    return items
      .filter((item) => allowedComponents.includes(item.name))
      .map((item) => ({
        ...item,
        submenu: item.submenu
          ? filterMenuItems(item.submenu, allowedComponents)
          : undefined,
      }));
  };
  
  const components = window.sessionStorage.getItem("components");
  const allowedComponents = components ? components.split(",") : [];
  const excludeForAdmin = ["Mis Solicitudes", "Solicitud PAP"];
  const filteredMenuItems = groups === "Administrador" 
  ? menuItems.filter(item => !excludeForAdmin.includes(item.name))
  : filterMenuItems(menuItems, allowedComponents);

  const Logoutfun = () => {
    fetch(url_logout, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ user: id }),
    }).then(async function (response) {
      if (response.status === 200) {
        window.sessionStorage.clear();
        window.location.href = "./";
      } else {
        Swal.fire({
          title: "Error!",
          footer: "Fallo en el servidor",
          icon: "error",
          showConfirmButton: false,
          timer: 2000,
        });
      }
    });
  };
    
  return (
    <div className="flex h-screen w-full bg-gray-100 overflow-hidden">
      {/* Desktop Sidebar */}
      <div
        className={`hidden md:flex flex-col ${
          isSidebarOpen ? "w-68 lg:w-68" : "w-16"
        } bg-white shadow-lg transition-all duration-300 min-h-screen`}
      >
        {/* Logo and Toggle Button */}
        <div className="flex items-center justify-between p-2 border-b">
          {isSidebarOpen && (
            <Link to="/Dashboardprincipal" className="flex-1 flex justify-center">
              <img src={Logonew} alt="Logo" className="h-12 lg:h-16" />
            </Link>
          )}
          <IconButton onClick={toggleSidebar} size="small">
            {isSidebarOpen ? <MenuOpen /> : <Menu />}
          </IconButton>
        </div>

        {/* Menu Items */}
        <div className="flex-1 overflow-y-auto py-2 md:py-4">
          {renderMenuItems(filteredMenuItems)}
        </div>

        {/* User Profile */}
        <div className="p-2 md:p-4 text-white flex items-center bg-colorsecondary">
          <div className="flex-shrink-0 cursor-pointer hover:bg-colorprimary hover:border-colorprimary rounded-[5px]">
            <LogOut className="w-6 h-6 md:w-8 md:h-8" onClick={Logoutfun}/>
          </div>

          {isSidebarOpen && (
            <div className="flex-1 flex flex-col items-center text-center ml-2">
              {/* Hacer que el nombre del usuario sea responsive test*/}
              <div className="font-bold truncate text-sm md:text-base leading-tight">
                {ownername}
              </div>
              <div 
                className="flex items-center gap-1 md:gap-2 bg-white p-1 rounded-lg text-colorprimary"
              >
                <UserCircleAlt className="w-4 h-4 md:w-6 md:h-6" />
                <span className="truncate text-xs md:text-sm">{groups}</span>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Mobile Drawer */}
      <Drawer
        anchor="left"
        open={isMobileMenuOpen}
        onClose={toggleMobileMenu}
        PaperProps={{
          sx: {
            backgroundColor: "#4a1272",
            width: 280,
            bgcolor: 'white'
          }
        }}
      >
        <div className="flex flex-col h-full">
          <div className="flex items-center justify-between p-4 border-b">
            <Link to="/Dashboardprincipal" onClick={toggleMobileMenu}>
              <img src={Logonew} alt="Logo" className="h-10" />
            </Link>
            <IconButton onClick={toggleMobileMenu}>
              <Close />
            </IconButton>
          </div>
          <div className="flex-1 overflow-y-auto py-2">
            {renderMenuItems(filteredMenuItems, true)}
          </div>
          <div className="p-4 bg-colorprimary text-white">
            <div className="flex items-center gap-3">
              <UserCircleAlt className="w-6 h-6 md:w-8 md:h-8" />
              <div className="overflow-hidden">
                <div className="font-bold truncate text-sm md:text-base">{ownername}</div>
                <div className="text-xs md:text-sm truncate">{groups}</div>
              </div>
              <LogOut className="w-6 h-6 md:w-8 md:h-8" onClick={Logoutfun}/>
            </div>
          </div>
        </div>
      </Drawer>

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Mobile Header */}
        <div className="md:hidden flex items-center justify-between p-2 md:p-4 bg-white shadow-sm">
          <IconButton onClick={toggleMobileMenu}>
            <Menu />
          </IconButton>
          <Link to="/Dashboardprincipal">
            <img src={Logonew} alt="Logo" className="h-8" />
          </Link>
          <div className="w-8"></div>
        </div>

        {/* Page Content */}
        <div className="flex-1 overflow-y-auto p-2 md:p-4 lg:p-6 bg-gray-100">
          {children}
        </div>
      </div>
    </div>
  );
}